import { render, staticRenderFns } from "./etapa_3.vue?vue&type=template&id=5dad58ba&scoped=true&"
import script from "./etapa_3.vue?vue&type=script&lang=js&"
export * from "./etapa_3.vue?vue&type=script&lang=js&"
import style0 from "./etapa_3.vue?vue&type=style&index=0&id=5dad58ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad58ba",
  null
  
)

export default component.exports